import { NAMESPACE } from './constants.js';
import { NetworkImageIds } from './presets.js';
export function getCaipDefaultChain(chain) {
    if (!chain) {
        return undefined;
    }
    return {
        id: `${NAMESPACE}:${chain.id}`,
        name: chain.name,
        imageId: NetworkImageIds[chain.id]
    };
}
export function getCaipTokens(tokens) {
    if (!tokens) {
        return undefined;
    }
    const caipTokens = {};
    Object.entries(tokens).forEach(([id, token]) => {
        caipTokens[`${NAMESPACE}:${id}`] = token;
    });
    return caipTokens;
}
export function caipNetworkIdToNumber(caipnetworkId) {
    return caipnetworkId ? Number(caipnetworkId.split(':')[1]) : undefined;
}
export function getDefaultWindowProvider() {
    if (typeof window === 'undefined') {
        return undefined;
    }
    const ethereum = window.ethereum;
    if (ethereum?.providers) {
        return ethereum.providers[0];
    }
    return ethereum;
}
//# sourceMappingURL=helpers.js.map